


export class MyPaypalConfig {
  customCardFilling = false
  payLaterOption = false
  preCalculatedPrice = 0
  refundable = true
  createOrderOnServer: (data: any, actions: any) => Promise<MyPaypalTransactionInfo>;
  onApprove?: (data: any, actions: any) => Promise<void>;
  onCancel?: (data: any, actions: any) => Promise<void>;
  onError?: (err: any) => Promise<void>;
}

export class MyPaypalTransactionInfo {
  price: number
  orderId: string
}
